import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '../axiosConfig';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [backgroundColor, setBackgroundColor] = useState('#ff5e57'); // 默认颜色

  useEffect(() => {
    const loadBackgroundColor = async () => {
      try {
        const res = await axios.get('/config/list', {
          params: { page: 1, limit: 1, sort: 'id', name: 'homepage_footer_config' },
        });
        if (
          res.data &&
          res.data.code === 0 &&
          res.data.data.list &&
          res.data.data.list.length > 0
        ) {
          const row = res.data.data.list[0];
          if (row.value) {
            try {
              const obj = JSON.parse(row.value);
              const bgColor = obj.backgroundColor || '#ff5e57';
              setBackgroundColor(bgColor);
              // 设置 CSS 变量，供全局 CSS 使用
              document.documentElement.style.setProperty('--theme-primary-color', bgColor);
            } catch (e) {
              console.error('Failed to parse backgroundColor config', e);
            }
          }
        }
      } catch (e) {
        console.error('Failed to load backgroundColor config', e);
      }
    };

    loadBackgroundColor();
  }, []);

  return (
    <ThemeContext.Provider value={{ backgroundColor }}>
      {children}
    </ThemeContext.Provider>
  );
};
